import styled from "styled-components";

export const AssignedManagerItemStyles = styled.div`
  display: flex;
  align-items: center;

  .name {
    flex: 1;
    font-weight: 600;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    padding-right: ${({ theme }) => theme.spacing[24]};
  }

  .contact {
    width: 190px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  .email {
    width: 240px;
    flex-shrink: 0;
    padding-right: ${({ theme }) => theme.spacing[16]};
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
